import { FC } from 'react';
import { Box, Text } from '@chakra-ui/react';

interface GraphTooltipLabelProps {
  title: string;
  text: string;
}

const GraphTooltipLabel: FC<GraphTooltipLabelProps> = ({ text, title }) => (
  <Box paddingX="space-4">
    <Text color="grey.400" size="xs">
      {title}
    </Text>
    <Text color="grey.100" fontSize="13px" fontWeight="weight-500">
      {text}
    </Text>
  </Box>
);

export default GraphTooltipLabel;
